<template>
	<div class="type-Header">
		<div class="type-Header-container">
			<div class="type-Header-logo">
				<type-image :src="logo" mode="heightFix"></type-image>
			</div>
			<div class="type-Header-menu" :class="_class">
                <my-icon class="type-Header-menu-icon" size="40px" color="#FFFFFF" :icon="isShow ? 'close' : 'burger'" @click="isShow = !isShow"></my-icon>
				<div class="type-Header-menu-container">
					<div class="type-Header-menu-content" v-for="(items, index) in showData.data" :key="index">
						<!-- <div class="menu-content-title" v-if="items.title" @click="toggle(index)" :class="items.isShow ? 'menu-active' : ''">{{ items.title }}</div> -->
						
						<div class="menu-content-title" 
     						v-if="items.title" 
     						@click="handleMenuClick(index, items)" 
     						:class="items.isShow ? 'menu-active' : ''">
    						{{ items.title }}
						</div>
						
						<transition name="slide">
							<div class="type-Header-menu-block" v-if="items.data.length" v-show="items.isShow">
								<div class="menu-content-subtitle" :key="i" v-if="item.title" v-for="(item, i) in items.data" @click="jump(item)">{{ item.title }}</div>
							</div>
						</transition>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	// 头部导航栏
	import mixin from '../mixin.js'
	export default {
		name: 'type-Header',
		mixins: [ mixin ],
		data() {
			return {
				isShow: false
			}
		},
		methods: {
			jump(item) {
				this.showData.data.forEach(v => v.isShow = false);
				this.jumpAction(item);
			},
			toggle(index) {
				const isShow = !(this.showData.data[index].isShow);
                for (let i = 0, length = this.showData.data.length; i < length; i++) {
                    this.showData.data[i].isShow = i === index ? isShow : false;
                }
			},
			handleMenuClick(index, item) {
                // Check if the clicked item has a submenu
                if (item.data && item.data.length > 0) {
                    // If it has a submenu, toggle its visibility
                    this.toggle(index);
                } else {
                    // If it does not have a submenu, perform the jump action
                    this.jump(item);
                }
            }

		},
		computed: {
			logo() {
				return this.showData.logo || 'https://resources.xitohere.com/xito/xitoDBG.png';
			},
			_class() {
				return this.isShow ? 'mobile-show' : '';
			}
		}
	}
</script>

<style scoped lang="less">
	.type-Header{
		color: #FFFFFF;
		position: absolute;
		top: 0;
		left: 0;
		z-index: 99;
		display: flex;
		margin: 0!important;
		pointer-events: none;
		background-color: transparent;
		.type-Header-container{
			width: 100%;
			display: flex;
			align-items: center;
			transition: height 500ms linear;
			pointer-events: auto;
			.type-Header-logo{
				height: 100%;
				width: 200px;
			}
			.type-Header-menu{
				height: 100%;
				width: calc(100% - 200px);
				text-align: right;
				.type-Header-menu-icon{}
				.type-Header-menu-container{
					cursor: pointer;
					.menu-content-title{
						font-size: 16px;
						font-weight: 300;
						font-family: 'D-DIN', sans-serif;
						white-space: nowrap;
					}
					.type-Header-menu-block{
						overflow: hidden;
						.menu-content-subtitle{
							font-size: 14px;
							font-weight: 300;
							font-family: 'D-DIN', sans-serif;
							white-space: nowrap;
						}
					}
					.slide-enter-active{
						opacity: 0;
						max-height: 0;
						animation: slide-enter 500ms forwards;
					}
					@keyframes slide-enter{
						from{
							opacity: 0;
							max-height: 0;
						}
						to{
							opacity: 1;
							max-height: 500px;
						}
					}
					.slide-leave-active{
						opacity: 1;
						max-height: 500px;
						animation: slide-leave 500ms forwards;
					}
					@keyframes slide-leave{
						from{
							opacity: 1;
							max-height: 500px;
						}
						to{
							opacity: 0;
							max-height: 0;
						}
					}
				}
			}
		}
	}
	@media screen and (min-width: 1400px){
		.type-Header{
			padding: 60px calc(50% - 640px);
			width: 1280px;
		}
	}
	@media screen and (min-width: 960px) and (max-width: 1399px){
		.type-Header{
			padding: 60px;
			width: calc(100% - 120px);
		}
	}
	@media screen and (min-width: 960px){
		@width: 120px;
		@height: 80px;
		.type-Header{
			.type-Header-container{
				height: @height;
				.type-Header-logo{}
				.type-Header-menu{
					.type-Header-menu-icon{
						display: none;
					}
					.type-Header-menu-container{
						height: 100%;
						display: inline-flex;
						align-items: center;
						.type-Header-menu-content{
							width: @width;
							height: 100%;
							position: relative;
							.menu-content-title{
								width: calc(100% - 20px);
								height: 100%;
								padding: 0 10px;
								display: inline-flex;
								align-items: center;
							}
							.menu-active{}
							.type-Header-menu-block{
								min-width: @width;
								position: absolute;
								top: @height;
								left: 0;
								background-color: rgba(0, 0, 0, 0.75);
								.menu-content-subtitle{
									padding: 5px 10px;
									text-align: left;
								}
							}
						}
					}
				}
			}
		}
	}
	@media screen and (max-width: 959px){
		@height: 60px;
		.type-Header{
			padding: 40px;
			width: calc(100% - 80px);
			.type-Header-container{
				height: @height;
				.type-Header-logo{}
				.type-Header-menu{
					display: flex;
					align-items: center;
					justify-content: flex-end;
					position: relative;
					.type-Header-menu-container{
						display: none;
						position: absolute;
						top: @height;
						right: 0;
						width: calc(100% + 200px);
						background-color: rgba(0, 0, 0, 0.75);
						overflow: hidden;
						.type-Header-menu-content{
							width: 100%;
							.menu-content-title{
								width: 100%;
								padding: 12px 0;
								text-align: center;
							}
							.type-Header-menu-block{
								min-width: 100%;
								.menu-content-subtitle{
									padding: 8px 0;
									text-align: center;
									&:last-child{
										border-bottom: 1px solid rgba(255, 255, 255, 0.5);
									}
								}
							}
							.menu-active{
								border-bottom: 2px solid #FFFFFF;
							}
						}
					}
				}
				.mobile-show{
					.type-Header-menu-container{
						display: block;
					}
				}
			}
		}
	}
</style>
